import {
  collection,
  addDoc,
  doc,
  updateDoc,
  serverTimestamp,
  deleteDoc,
} from 'firebase/firestore';
import { db } from './firebase';
import { currentDate } from './stores/appData';
import type { Holiday, ExtendedData } from './types/calendar';

import { isMonthOpen, isSideBarOpen, isYearOpen } from './stores/dropDowns';
import type { Data } from './types';

export const holidays = [
  { year: 'every', month: 'January', day: 1, event: "New Year's Day", short: '🎉' },
  { year: 'every', month: 'February', day: 14, event: "Valentine's Day", short: '♥️' },
  { year: 'every', month: 'March', day: 17, event: "St. Patrick's Day", short: '🍀' },
  { year: 'every', month: 'June', day: 19, event: 'Juneteenth' },
  { year: 'every', month: 'July', day: 4, event: 'Independence Day', short: '🇺🇸' },
  { year: 'every', month: 'October', day: 31, event: 'Halloween', short: '🎃' },
  { year: 'every', month: 'November', day: 11, event: 'Veterans Day', short: '🇺🇸' },
  { year: 'every', month: 'December', day: 24, event: 'Christmas Eve', short: '🎅' },
  { year: 'every', month: 'December', day: 25, event: 'Christmas Day', short: '🎄' },
  { year: 'every', month: 'December', day: 31, event: 'New Years Eve', short: '🎆' },
  { year: 'every', month: 'February', day: 2, event: 'Groundhog Day', short: '🪵' },
  { year: 'every', month: 'April', day: 1, event: "April Fools' Day", short: '🃏' },
  { year: 'every', month: 'April', day: 22, event: 'Earth Day', short: '🌍' },
  { year: 'every', month: 'May', day: 5, event: 'Cinco de Mayo', short: '🇲🇽' },
  { year: 'every', month: 'June', day: 14, event: 'Flag Day', short: '🇺🇸' },
  {
    year: 2022,
    month: 'January',
    day: 17,
    event: 'MLK Jr. Day',
    short: 'MLK',
  },
  { year: 2022, month: 'February', day: 13, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2022, month: 'February', day: 21, event: "President's Day", short: '🇺🇸' },
  { year: 2022, month: 'April', day: 17, event: 'Easter', short: '🐰' },
  { year: 2022, month: 'May', day: 8, event: "Mother's Day", short: '🌸' },
  { year: 2022, month: 'May', day: 30, event: 'Memorial Day', short: '🇺🇸' },
  { year: 2022, month: 'June', day: 19, event: "Father's Day", short: '⚾' },
  { year: 2022, month: 'July', day: 4, event: 'Independence Day', short: '🇺🇸' },
  { year: 2022, month: 'September', day: 5, event: 'Labor Day', short: '🧑‍🏭' },
  { year: 2022, month: 'October', day: 10, event: 'Columbus Day', short: '⛵' },
  {
    year: 2022,
    month: 'October',
    day: 10,
    event: "US Indigenous People's Day",
    short: '🪶',
  },
  { year: 2022, month: 'November', day: 24, event: 'Thanksgiving', short: '🦃' },
  { year: 2022, month: 'December', day: 18, event: 'Hanukkah Begins', short: '🕯️' },
  {
    year: 2023,
    month: 'January',
    day: 16,
    event: 'MLK Jr. Day',
    short: 'MLK',
  },
  { year: 2023, month: 'February', day: 12, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2023, month: 'February', day: 20, event: "President's Day", short: '🇺🇸' },
  { year: 2023, month: 'April', day: 9, event: 'Easter', short: '🐰' },
  { year: 2023, month: 'May', day: 14, event: "Mother's Day", short: '🌸' },
  { year: 2023, month: 'May', day: 29, event: 'Memorial Day', short: '🇺🇸' },
  { year: 2023, month: 'June', day: 18, event: "Father's Day", short: '⚾' },
  { year: 2023, month: 'September', day: 4, event: 'Labor Day', short: '🧑‍🏭' },
  { year: 2023, month: 'October', day: 9, event: 'Columbus Day', short: '⛵' },
  {
    year: 2023,
    month: 'October',
    day: 9,
    event: "US Indigenous People's Day",
    short: '🪶',
  },
  { year: 2023, month: 'November', day: 23, event: 'Thanksgiving', short: '🦃' },
  { year: 2023, month: 'December', day: 7, event: 'Hanukkah Begins', short: '🕯️' },
  {
    year: 2024,
    month: 'January',
    day: 15,
    event: 'MLK Jr. Day',
    short: 'MLK',
  },
  { year: 2024, month: 'February', day: 11, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2024, month: 'February', day: 19, event: "President's Day", short: '🇺🇸' },
  { year: 2024, month: 'April', day: 7, event: 'Easter', short: '🐰' },
  { year: 2024, month: 'May', day: 12, event: "Mother's Day", short: '🌸' },
  { year: 2024, month: 'May', day: 27, event: 'Memorial Day', short: '🇺🇸' },
  { year: 2024, month: 'June', day: 16, event: "Father's Day", short: '⚾' },
  { year: 2024, month: 'September', day: 2, event: 'Labor Day', short: '🧑‍🏭' },
  { year: 2024, month: 'October', day: 14, event: 'Columbus Day', short: '⛵' },
  {
    year: 2024,
    month: 'October',
    day: 14,
    event: "US Indigenous People's Day",
    short: '🪶',
  },
  { year: 2024, month: 'November', day: 28, event: 'Thanksgiving', short: '🦃' },
  { year: 2024, month: 'December', day: 22, event: 'Hanukkah Begins', short: '🕯️' },
  {
    year: 2025,
    month: 'January',
    day: 20,
    event: 'MLK Jr. Day',
    short: 'MLK',
  },
  { year: 2025, month: 'February', day: 9, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2025, month: 'February', day: 17, event: "President's Day", short: '🇺🇸' },
  { year: 2025, month: 'April', day: 20, event: 'Easter', short: '🐰' },
  { year: 2025, month: 'May', day: 11, event: "Mother's Day", short: '🌸' },
  { year: 2025, month: 'May', day: 26, event: 'Memorial Day', short: '🇺🇸' },
  { year: 2025, month: 'June', day: 15, event: "Father's Day", short: '⚾' },
  { year: 2025, month: 'September', day: 1, event: 'Labor Day', short: '🧑‍🏭' },
  { year: 2025, month: 'October', day: 13, event: 'Columbus Day', short: '⛵' },
  {
    year: 2025,
    month: 'October',
    day: 13,
    event: "US Indigenous People's Day",
    short: '🪶',
  },
  { year: 2025, month: 'November', day: 27, event: 'Thanksgiving', short: '🦃' },
  { year: 2025, month: 'December', day: 12, event: 'Hanukkah Begins', short: '🕯️' },
  {
    year: 2026,
    month: 'January',
    day: 19,
    event: 'MLK Jr. Day',
    short: 'MLK',
  },
  { year: 2026, month: 'February', day: 8, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2026, month: 'February', day: 16, event: "President's Day", short: '🇺🇸' },
  { year: 2026, month: 'April', day: 5, event: 'Easter', short: '🐰' },
  { year: 2026, month: 'May', day: 10, event: "Mother's Day", short: '🌸' },
  { year: 2026, month: 'May', day: 25, event: 'Memorial Day', short: '🇺🇸' },
  { year: 2026, month: 'June', day: 21, event: "Father's Day", short: '⚾' },
  { year: 2026, month: 'September', day: 7, event: 'Labor Day', short: '🧑‍🏭' },
  { year: 2026, month: 'October', day: 12, event: 'Columbus Day', short: '⛵' },
  {
    year: 2026,
    month: 'October',
    day: 12,
    event: "US Indigenous People's Day",
    short: '🪶',
  },
  { year: 2026, month: 'November', day: 26, event: 'Thanksgiving', short: '🦃' },
  { year: 2026, month: 'December', day: 1, event: 'Hanukkah Begins', short: '🕯️' },
  // 2027
  { year: 2027, month: 'January', day: 18, event: 'MLK Jr. Day', short: 'MLK' },
  { year: 2027, month: 'February', day: 14, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2027, month: 'February', day: 15, event: "President's Day", short: '🇺🇸' },
  { year: 2027, month: 'March', day: 28, event: 'Easter', short: '🐰' },
  { year: 2027, month: 'May', day: 9, event: "Mother's Day", short: '🌸' },
  { year: 2027, month: 'May', day: 31, event: 'Memorial Day', short: '🇺🇸' },
  { year: 2027, month: 'June', day: 20, event: "Father's Day", short: '⚾' },
  { year: 2027, month: 'September', day: 6, event: 'Labor Day', short: '🧑‍🏭' },
  { year: 2027, month: 'October', day: 11, event: 'Columbus Day', short: '⛵' },
  {
    year: 2027,
    month: 'October',
    day: 11,
    event: "US Indigenous People's Day",
    short: '🪶',
  },
  { year: 2027, month: 'November', day: 25, event: 'Thanksgiving', short: '🦃' },
  { year: 2027, month: 'December', day: 24, event: 'Hanukkah Begins', short: '🕯️' },

  // 2028
  { year: 2028, month: 'January', day: 17, event: 'MLK Jr. Day', short: 'MLK' },
  { year: 2028, month: 'February', day: 13, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2028, month: 'February', day: 21, event: "President's Day", short: '🇺🇸' },
  { year: 2028, month: 'April', day: 16, event: 'Easter', short: '🐰' },
  { year: 2028, month: 'May', day: 14, event: "Mother's Day", short: '🌸' },
  { year: 2028, month: 'May', day: 29, event: 'Memorial Day', short: '🇺🇸' },
  { year: 2028, month: 'June', day: 18, event: "Father's Day", short: '⚾' },
  { year: 2028, month: 'September', day: 4, event: 'Labor Day', short: '🧑‍🏭' },
  { year: 2028, month: 'October', day: 9, event: 'Columbus Day', short: '⛵' },
  {
    year: 2028,
    month: 'October',
    day: 9,
    event: "US Indigenous People's Day",
    short: '🪶',
  },
  { year: 2028, month: 'November', day: 23, event: 'Thanksgiving', short: '🦃' },
  { year: 2028, month: 'December', day: 12, event: 'Hanukkah Begins', short: '🕯️' },

  // 2029
  { year: 2029, month: 'January', day: 15, event: 'MLK Jr. Day', short: 'MLK' },
  { year: 2029, month: 'February', day: 11, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2029, month: 'February', day: 19, event: "President's Day", short: '🇺🇸' },
  { year: 2029, month: 'April', day: 1, event: 'Easter', short: '🐰' },
  { year: 2029, month: 'May', day: 13, event: "Mother's Day", short: '🌸' },
  { year: 2029, month: 'May', day: 28, event: 'Memorial Day', short: '🇺🇸' },
  { year: 2029, month: 'June', day: 17, event: "Father's Day", short: '⚾' },
  { year: 2029, month: 'September', day: 3, event: 'Labor Day', short: '🧑‍🏭' },
  { year: 2029, month: 'October', day: 8, event: 'Columbus Day', short: '⛵' },
  {
    year: 2029,
    month: 'October',
    day: 8,
    event: "US Indigenous People's Day",
    short: '🪶',
  },
  { year: 2029, month: 'November', day: 22, event: 'Thanksgiving', short: '🦃' },
  { year: 2029, month: 'December', day: 1, event: 'Hanukkah Begins', short: '🕯️' },

  // 2030
  { year: 2030, month: 'January', day: 21, event: 'MLK Jr. Day', short: 'MLK' },
  { year: 2030, month: 'February', day: 10, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2030, month: 'February', day: 18, event: "President's Day", short: '🇺🇸' },
  { year: 2030, month: 'April', day: 21, event: 'Easter', short: '🐰' },
  { year: 2030, month: 'May', day: 12, event: "Mother's Day", short: '🌸' },
  { year: 2030, month: 'May', day: 27, event: 'Memorial Day', short: '🇺🇸' },
  { year: 2030, month: 'June', day: 16, event: "Father's Day", short: '⚾' },
  { year: 2030, month: 'September', day: 2, event: 'Labor Day', short: '🧑‍🏭' },
  { year: 2030, month: 'October', day: 14, event: 'Columbus Day', short: '⛵' },
  {
    year: 2030,
    month: 'October',
    day: 14,
    event: "US Indigenous People's Day",
    short: '🪶',
  },
  { year: 2030, month: 'November', day: 28, event: 'Thanksgiving', short: '🦃' },
  { year: 2030, month: 'December', day: 21, event: 'Hanukkah Begins', short: '🕯️' },
  { year: 2027, month: 'February', day: 14, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2028, month: 'February', day: 13, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2029, month: 'February', day: 11, event: 'Super Bowl Sunday', short: '🏈' },
  { year: 2030, month: 'February', day: 10, event: 'Super Bowl Sunday', short: '🏈' },
];

export const daysOfTheWeek = [
  '<p aria-label="Sunday">S<span arial-hidden="true">unday</span></p>',
  '<p aria-label="Monday">M<span arial-hidden="true">onday</span></p>',
  '<p aria-label="Tuesday">T<span arial-hidden="true">ueday</span></p>',
  '<p aria-label="Wednesday">W<span arial-hidden="true">ednesday</span></p>',
  '<p aria-label="Thursday">T<span arial-hidden="true">hurday</span></p>',
  '<p aria-label="Friday">F<span arial-hidden="true">riday</span></p>',
  '<p aria-label="Saturday">S<span arial-hidden="true">aturday</span></p>',
];
export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const displayYears = [2021, 2022, 2023, 2024, 2025, 2026];

export function toggleOpen() {
  isSideBarOpen.update(open => !open);
}

export async function addDataToFirestore(data: Data, userId: string) {
  try {
    if (data) {
      const newDocRef = collection(db, 'newMenus', userId, data.year.toString());
      await addDoc(newDocRef, { ...data, timestamp: serverTimestamp() });
    }
  } catch (error) {
    console.error('addDataToFirestore failed', error);
    throw error;
  }
}
export async function updateDataInFirestore(data: Data, userId: string) {
  try {
    if (!data.id) throw new Error('Document ID is required');
    const newDocRef = doc(db, 'newMenus', userId, data.year.toString(), data.id);
    await updateDoc(newDocRef, { ...data, timestamp: serverTimestamp() });
  } catch (error) {
    console.error('updateDataInFirestore failed', error);
    throw error;
  }
}

export async function deleteItem(userId: string, year: string, docId: string) {
  try {
    const newDocRef = doc(db, 'newMenus', userId, year, docId);
    await deleteDoc(newDocRef);
  } catch (error) {}
}

export const closeAll = () => {
  isMonthOpen.set(false);
  isYearOpen.set(false);
  isSideBarOpen.set(false);
};

export const setNewDate = (newYear: number = 2021, newMonth: number) => {
  currentDate.set(new Date(newYear, newMonth));
};

export function getHSLArray(hslColor: string): string | undefined {
  if (!hslColor) return;
  const [h, s, l] = hslColor
    .replace(/hsl\(([\d, %]*)\)/, '$1')
    .replace(/ /g, '')
    .replace(/%/g, '')
    .split(',');
  const hexColor = hslToHex(Number(h), Number(s), Number(l));
  return hexColor;
}

function hslToHex(h: number, s: number, l: number): string {
  l /= 100;
  const a = (s * Math.min(l, 1 - l)) / 100;
  const f = (n: number): string => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0'); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

/**
 * Scrolls to a specific element with smooth behavior
 * @param element The HTML element to scroll to
 */
export function scrollToElement(element: HTMLElement | null | undefined): void {
  if (!element) return;
  const { top } = element.getBoundingClientRect();
  window.scrollTo({ top, left: 0, behavior: 'smooth' });
}

/**
 * Gets the height of an HTML element
 * @param element The HTML element to measure
 * @returns The height of the element or 0 if element is null/undefined
 */
export function getElementHeight(element: HTMLElement | null | undefined): number {
  if (!element) return 0;
  const { height } = element.getBoundingClientRect();
  return height;
}

/**
 * Checks if an element is visible based on its position relative to a threshold
 * @param element The element to check visibility for
 * @param threshold The position threshold (typically the height of a fixed header)
 * @returns Boolean indicating if the element is above the threshold (and thus potentially hidden)
 */
export function isElementVisible(
  element: HTMLElement | null | undefined,
  threshold: number,
): boolean {
  if (!element) return false;
  const { top } = element.getBoundingClientRect();
  return top < threshold;
}

/**
 * Generates an array of days for the current month, combining Firestore data with holiday information
 * @param year The year
 * @param month The month (0-11)
 * @param monthLabel The month label (e.g., "January")
 * @param firestoreData Array of data from Firestore
 * @param holidaysData Array of holiday data
 * @returns Array of days with combined data
 */
export function generateDaysInMonth(
  year: number,
  month: number,
  monthLabel: string,
  firestoreData: ExtendedData[],
  holidaysData: Holiday[],
): ExtendedData[] {
  // Calculate days in month using the trick with day 32 (which overflows to next month)
  const daysInMonth = 32 - new Date(year, month, 32).getDate();

  // Filter holidays for current month/year
  const thisMonthsHolidays = holidaysData.filter(
    holiday =>
      holiday.month === monthLabel && (holiday.year === year || holiday.year === 'every'),
  );

  // Generate days array
  return Array.from({ length: daysInMonth })
    .map((_, index) => {
      const day = index + 1;
      const [dayHasData] = firestoreData.filter(d => d.day === day);

      // If we have data for this day in Firestore, use it; otherwise create a base object
      const baseData = dayHasData || ({ day, month: monthLabel, year } as ExtendedData);
      return baseData;
    })
    .map(item => {
      // Add holiday information if this day has a holiday
      const [holiday] = thisMonthsHolidays.filter(holiday => holiday.day === item.day);
      if (holiday) {
        const { event, short } = holiday;
        return { ...item, event, short };
      }
      return item;
    });
}

/**
 * Generates days from the previous month to fill the first row of the calendar
 * @param year The year
 * @param month The month number (0-11) for the previous month
 * @param monthLabel The month label (e.g., "January") for the previous month
 * @param firstDay The index of the first day of the current month (0-6)
 * @param firestoreData Array of data from Firestore for the previous month
 * @returns Array of days from the previous month to display
 */
export function generatePreviousMonthDays(
  year: number,
  month: number, // month index (0-11) of the previous month
  monthLabel: string,
  firstDayCurrentMonth: number, // Index of the first day of the *current* month (0-6)
  firestoreData: ExtendedData[], // Firestore data for the *previous* month
): ExtendedData[] {
  const daysInPrevMonth = 32 - new Date(year, month, 32).getDate();

  // Filter holidays for the actual previous month and year
  const prevMonthsHolidays = holidays.filter(
    holiday =>
      holiday.month === monthLabel && (holiday.year === year || holiday.year === 'every'),
  );

  // Generate the days to display from the previous month
  return Array.from({ length: firstDayCurrentMonth }).map((_, index) => {
    // Calculate the actual day number for the previous month
    const day = daysInPrevMonth - (firstDayCurrentMonth - 1 - index);

    // Check if there's Firestore data for this specific day of the previous month
    const [dayHasData] = firestoreData.filter(
      d => d.day === day && d.month === monthLabel && d.year === year,
    );

    const baseData = dayHasData || ({ day, month: monthLabel, year } as ExtendedData);

    // Add holiday information if this day has a holiday
    const [holiday] = prevMonthsHolidays.filter(h => h.day === day);
    if (holiday) {
      const { event, short } = holiday;
      return { ...baseData, event, short };
    }
    return baseData;
  });
}

/**
 * Generates days from the next month to fill the remaining spots in the last row of the calendar
 * @param year The current year
 * @param month The current month number (0-11)
 * @param totalDaysRenderedFromPrevAndCurrent The total number of days already rendered (previous month's visible days + current month's days)
 * @param firestoreData Array of data from Firestore for the actual next month (e.g., July 2025)
 * @param nextMonthActualYear The actual year of the next month (e.g., 2025 for July)
 * @param nextMonthActualMonthIndex The actual month index of the next month (e.g., 6 for July)
 * @returns Array of days from the next month to display
 */
export function generateNextMonthDays(
  currentDisplayYear: number, // Year of the month currently being displayed (e.g., June 2025)
  currentDisplayMonthIndex: number, // Month index of the month currently being displayed (e.g., 5 for June)
  totalDaysRenderedFromPrevAndCurrent: number,
  firestoreData: ExtendedData[], // Data fetched for the actual next month (e.g., July 2025)
  nextMonthActualYear: number, // Actual year of the next month (e.g., 2025 for July)
  nextMonthActualMonthIndex: number, // Actual month index of the next month (e.g., 6 for July)
): ExtendedData[] {
  const daysRenderedMod7 = totalDaysRenderedFromPrevAndCurrent % 7;

  if (daysRenderedMod7 === 0 && totalDaysRenderedFromPrevAndCurrent > 0) {
    return [];
  }

  if (totalDaysRenderedFromPrevAndCurrent === 0) {
    return [];
  }

  const cellsToFill = 7 - daysRenderedMod7;

  if (cellsToFill <= 0 || cellsToFill > 6) {
    return [];
  }

  // Use the provided actual year and month index for the next month
  const nextMonthLabel = months[nextMonthActualMonthIndex];

  // Filter holidays for the actual next month and year
  const nextMonthsHolidays = holidays.filter(
    holiday =>
      holiday.month === nextMonthLabel &&
      (holiday.year === nextMonthActualYear || holiday.year === 'every'),
  );

  return Array.from({ length: cellsToFill }).map((_, index) => {
    const day = index + 1;
    // Check if there's Firestore data for this specific day of the next month
    const [dayHasData] = firestoreData.filter(
      d => d.day === day && d.month === nextMonthLabel && d.year === nextMonthActualYear,
    );

    const baseData =
      dayHasData ||
      ({ day, month: nextMonthLabel, year: nextMonthActualYear } as ExtendedData);

    // Add holiday information if this day has a holiday
    const [holiday] = nextMonthsHolidays.filter(h => h.day === day);
    if (holiday) {
      const { event, short } = holiday;
      return { ...baseData, event, short };
    }
    return baseData;
  });
}

/**
 * Safely gets the day from a Date object
 * @param date The date object
 * @returns The day of the month (1-31) or undefined if the date is invalid
 */
export function getDayFromDate(date: Date): number | undefined {
  try {
    return date.getDate();
  } catch (error) {
    return undefined;
  }
}

/**
 * Safely gets the year from a Date object
 * @param date The date object
 * @returns The year (e.g., 2023) or undefined if the date is invalid
 */
export function getYearFromDate(date: Date): number | undefined {
  try {
    return date.getFullYear();
  } catch (error) {
    return undefined;
  }
}

/**
 * Safely gets the month from a Date object
 * @param date The date object
 * @returns The month (0-11) or undefined if the date is invalid
 */
export function getMonthFromDate(date: Date): number | undefined {
  try {
    return date.getMonth();
  } catch (error) {
    return undefined;
  }
}
